import type { IconNode } from '../types';

/**
 * @name pin-safety
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMjAuOCAzLjJjLTEuNi0xLjYtNC4xLTEuNi01LjcgMEwxMi4zIDZTMTUgOSAxOCA2Yy0zIDMgMCA1LjcgMCA1LjdsMi44LTIuOGMxLjYtMS42IDEuNi00LjIgMC01LjciIC8+CiAgPHBhdGggZD0ibTcuMSAyMS4xIDEwLjMtMTAuMiIgLz4KICA8Y2lyY2xlIGN4PSI1IiBjeT0iMTkiIHI9IjMiIC8+CiAgPHBhdGggZD0iTTIuOSAxNi45IDEzLjEgNi42IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/pin-safety
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const pinSafety: IconNode = [
  [
    'path',
    {
      d: 'M20.8 3.2c-1.6-1.6-4.1-1.6-5.7 0L12.3 6S15 9 18 6c-3 3 0 5.7 0 5.7l2.8-2.8c1.6-1.6 1.6-4.2 0-5.7',
      key: 'g65cz9',
    },
  ],
  ['path', { d: 'm7.1 21.1 10.3-10.2', key: '1htvo3' }],
  ['circle', { cx: '5', cy: '19', r: '3', key: '1sn6vo' }],
  ['path', { d: 'M2.9 16.9 13.1 6.6', key: '1ej3li' }],
];

export default pinSafety;
